import fEvents from '../../js/events';

export enum BUTTON_STATE {
    loading = 'loading',
    none = 'none',
}

//@deprecated use default-button instead
export default class ButtonStateful extends HTMLElement {

    private props: {
        text: string,
        width: string,
        height: string,
        backgroundcolor: string,
        icon: string,
        color: string,
        rounded: string,
        textsize: string,
        textalign: string,
        loadingtext: string,
        type: string,
        iconSize: string,
        minwidth: string,
        state: BUTTON_STATE
    };

    constructor() {
        super();
        this.props = {
            text: '',
            width: 'fit-content',
            height: '32px',
            'minwidth': '100px',
            rounded: '0px',
            textsize: '14px',
            backgroundcolor: 'white',
            color: 'black',
            textalign: 'none',
            type: 'button',
            icon: '',
            iconSize: '18px',
            loadingtext: 'Loading... please wait',
            state: BUTTON_STATE.none
        };
        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.innerHTML = this.render(this.props);

        fEvents.attachEvent('#button', 'click', () => {
            this.onElementClick();
        }, shadowRoot);
    }

    attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {

        if (!ButtonStateful.observedAttributes.includes(attrName)) {
            return; // not a valid field
        }
        this.props[attrName] = newVal;
        const newProps = {
            ...this.props,
            [attrName] : newVal
        };

        this.shadowRoot.innerHTML = this.render(newProps);
    }

    get isDisabled () {
        return this.hasAttribute('disabled');
    }

    static get observedAttributes(): string[] {
        return ['text', 'width', 'backgroundcolor', 'color' ,'state', 'height', 'icon', 'rounded', 'textsize', 'textalign', 'type', 'disabled', 'loadingtext', 'minwidth', 'buttonstyle'];
    }

    private onElementClick() {
        if (this.props.state !== BUTTON_STATE.loading) {
            this.dispatchEvent(new CustomEvent('btn-clicked'));
        }
    }

    render = newProps => {
        const isLoading = newProps.state === BUTTON_STATE.loading;
        const buttonStyle = newProps.buttonstyle || '';

        return `
        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
        <link rel="stylesheet" href="/styles/styles.css" type="text/css">
        <link rel="stylesheet" href="/styles/index.css" type="text/css">
        <style>
            :host {
                display: block;
                width: ${newProps.width || 'fit-content' };
            }

            #button{
                ${buttonStyle}
            }

            .text {
                padding: 50px;
                font-family: "Sans-Serif";
                color: #666;
            }

            .button {
                position: relative;
                width: ${newProps.width || '100%'};
                min-width: ${newProps.minwidth || '100px'};
                font-size: ${newProps.textsize || '14px'};
                display: flex;
                padding: 4px 8px;
                border: 1px solid #CDD5E4;
                justify-content: ${newProps.textalign || 'none'};
                align-items: center;
                border-radius: 4px;
                align-items: center;
                background-color: white;
                cursor: pointer;
                height: ${newProps.height || '32px'};
                box-sizing: border-box;
                color: ${newProps.color};
                border-radius: ${newProps.rounded || '0px'};
                background-color: ${newProps.backgroundcolor || '#ffffff'};
            }
            
            .button:hover {
               box-shadow: inset 0 0 0 99999px rgba(0, 0, 0, 0.05);
            }

            .button[disabled] {
                cursor: not-allowed;
                opacity: 0.5;
            }

            .button--loading{
                color: ${newProps.color};
            }

            .loader {
                position: relative;
                height: 20px;
                width: 20px;
                display: none;
                margin-right: 8px;
                animation: around 5.4s infinite;
            }

            .button--loading .loader {
                display: inline-block;
            }
            .error { display: none; color: var(--error) }
            .input__error .error { display: inline-block }
            .ok { display: none; color: #3fb848 }
            .input__ok .ok { display: inline-block }

            @keyframes around {
              0% {
                transform: rotate(0deg)
              }
              100% {
                transform: rotate(360deg)
              }
            }

            .loader::after, .loader::before {
                content: "";
                background: transparent;
                position: absolute;
                display: inline-block;
                width: 18px;
                height: 18px;
                border-width: 2px;
                border-color: #333 #333 transparent transparent;
                border-style: solid;
                border-radius: 20px;
                box-sizing: border-box;
                top: 0;
                left: 0;
                animation: around 0.7s ease-in-out infinite;
            }

            .loader::after {
                animation: around 0.7s ease-in-out 0.1s infinite;
                background: transparent;
            }

            .icon{
                font-size: ${newProps.iconSize || '18px'};
                margin-right: 8px;
            }

        </style>
        <button id="button" type=${newProps.type} ${isLoading || this.isDisabled ? 'disabled="true"': '' } class="button button--${newProps.state.toLowerCase()}">
              ${isLoading ? '<i class="loader"></i>' : newProps.icon && `<span class="material-icons icon">${newProps.icon}</span>`}
               ${isLoading ? newProps.loadingtext : newProps.text}
        </button>
    `;
    };}

//@deprecated use default-button instead
customElements.define('button-stateful', ButtonStateful);
